import React, { Component } from 'react';
import TeamInfo from './main/TeamInfo';
import Rankings from './main/Rankings';
import TeamLogo from './main/TeamLogo';
import Attendance from './main/Attendance';
import Roster from './main/Roster';
import Staff from './main/Staff';
import Links from './main/Links';
import Schedule from './main/Schedule';
import Loader from './nav/Loader';

import { connect } from "react-redux";
import { getDashboard } from "../actions";

class Main extends Component {
  constructor(props) {
    super(props);
    this.getContent = this.getContent.bind(this);
  }
  componentDidMount() {
    var team = this.props.teamFilter === undefined ? 0 : this.props.teamFilter;
    this.props.getDashboard({
      "year": this.props.yearFilter,
      "team": team
    });
  }
  componentDidUpdate(prevProps){
    if(prevProps.teamFilter !== this.props.teamFilter
      || prevProps.yearFilter !== this.props.yearFilter){
      this.props.getDashboard({
        "year": this.props.yearFilter,
        "team": this.props.teamFilter
      });
    }
  }
  getContent() {
    let smallContent = <div><div className="row expanded">
      <div className="small-12 medium-4 columns spacer5">
        <div className="mainLeft">
          <TeamInfo teamFilter={this.props.teamFilter} info={this.props.data.info}/>
        </div>
      </div>
      <div className="small-12 medium-8 columns spacer5">
        <div className="row expanded small-collapse">
          <div className="small-12 columns ">
            <Roster teamFilter={this.props.teamFilter} yearFilter={this.props.yearFilter}/>
          </div>
        </div>
      </div>
    </div>

    <div className="clearboth"></div>
    <div className="row expanded">
      <div className="small-12 columns spacer5">
        <div className="section-title">{this.props.yearFilter} Schedule</div>
        <Schedule teamFilter={this.props.teamFilter} meets={this.props.data.meets}/>
      </div>
    </div></div>;
    let content = <div>
      <div className="row expanded small-collapse">
        <div className="small-12 medium-12 large-4 columns spacer-right5">
          <TeamLogo teamFilter={this.props.teamFilter}/>
        </div>
        <div className="small-12 medium-12 large-4 columns spacer-right5">
          <Rankings teamFilter={this.props.teamFilter} ranks={this.props.data.ranks}/>
        </div>
        <div className="small-12 medium-12 large-4 columns spacer-left5">
          <Attendance teamFilter={this.props.teamFilter} attendance={this.props.data.attendance}/>
        </div>
      </div>
      <div className="row expanded small-collapse">
        <div className="small-12 columns ">
          <Roster teamFilter={this.props.teamFilter} yearFilter={this.props.yearFilter} meets={this.props.data.meets}/>
        </div>
      </div>
      <div className="row expanded small-collapse spacer-top10">
        <div className="small-12 medium-4 columns ">
          <Staff teamFilter={this.props.teamFilter} staff={this.props.data.staff}/>
        </div>
        <div className="small-12 medium-4 columns ">
          <Links teamFilter={this.props.teamFilter} links={this.props.data.links}/>
        </div>
        <div className="small-12 medium-4 columns ">
          <TeamInfo teamFilter={this.props.teamFilter} info={this.props.data.info}/>
        </div>
    </div>
    </div>;
    if(this.props.teamFilter > 0 && this.props.isValidTeamYear) {
      if(this.props.yearFilter > 1998){
        return content;
      } else {
        return smallContent;
      }
    } else {
      return <span>No Results</span>;
    }
  }
  render() {
    if(!this.props.showLoader){
      return (
        <div className="mainContainer">
          {this.getContent()}
        </div>
      );
    } else {
      return (
        <Loader />
      );
    }
  }
}

function mapStateToProps(state) {
  return {
    data: state.main.data,
    teamFilter: state.main.teamFilter,
    yearFilter: state.main.yearFilter,
    isValidTeamYear: state.main.isValidTeamYear,
    showLoader: state.main.showLoader
  };
}

export default connect(mapStateToProps, { getDashboard })(Main);
